import Helper from "./Helper";

class HeaderImg {
  constructor(config = {}) {
    const circles = Array.prototype.slice.call(document.querySelectorAll('.ns-header-img--triple-half-moon .triple-half-moon .circle'));
    if(circles){
      let i = 0;
      circles.forEach(element => {
        i++;
        setTimeout(() => { element.classList.remove('translated'); }, i*500);
      });
    }
  }
}
export default HeaderImg;
